import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Button, Container, Typography, Box, Card } from '@mui/material';
import * as React from 'react';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import { getApi, patchApi } from 'views/services/api';
import { useEffect } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
// ----------------------------------------------------------------------

const AdminComplaint = () => {
  const navigate = useNavigate();
  const [complaintData, setcomplaintData] = useState([]);
  const [statusChanged, setStatusChanged] = useState(false);

  // function for changing the complaint status ---------------------------------

  const handleOpenChangeStatus = async (complaintId) => {
    try {
      const response = await patchApi(`api/complaint/changecomplaintstatus/${complaintId}`);
      if (response.status === 200) {
        toast.success('Complaint resolved successfully');
        setStatusChanged((prevStatusChanged) => !prevStatusChanged);
      } else {
        setStatusChanged(false);
        toast.error('contact resolve complaint');
      }
    } catch (e) {
      setStatusChanged(false);
      console.log(e);
      toast.error('cannot resolve complaint');
    }
  };

  // function for fetching all the rooms data from the db

  const fetchcomplaintData = async () => {
    try {
      console.log("url hit ==>",`api/complaint/viewallcomplaints`);
      const response = await getApi(`api/complaint/viewallcomplaints`);
      console.log("response print hereeeeee  =====>",response);
      if(response.status=== 204){
        setcomplaintData([]);
      }else{
        setcomplaintData(response?.data?.mergedData);
      }
      
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchcomplaintData();
  }, [statusChanged]);

  const columns = [
    {
      field: 'hotelName',
      headerName: 'Hotel Name',
      flex: 1,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        return <Box onClick={() => navigate(`/dashboard/admincomplaint/view/${params.row._id}`)}>{params.value}</Box>;
      }
    },
    {
      field: 'type',
      headerName: 'Complaint Type',
      flex: 1
    },
    {
      field: 'description',
      headerName: 'Complaint Description',
      flex: 1
    },
    {
      field: 'createdDate',
      headerName: 'Created At',
      flex: 1,
      renderCell: (params) => {
        return <Box>{moment(params?.value).format('YYYY-MM-DD ( HH:mm:ss )')}</Box>;
      }
    },
    {
      field: 'status',
      headerName: 'Complaint Status',
      flex: 1,
      cellClassName: `name-column--cell--capitalize`,
      renderCell: (params) => {
        return params?.value === true ? (
          <Box sx={{ backgroundColor: '#42a142', color: 'white', padding: '10px', borderRadius: '10px' }}>Resolved</Box>
        ) : (
          <Button variant="contained" disabled>
            Pending
          </Button>
        );
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,

      renderCell: (params) => {
        return (
          <Button
            sx={{ fontSize: '11px' }}
            variant="contained"
            startIcon={<ChangeCircleIcon icon="eva:plus-fill" />}
            onClick={() => handleOpenChangeStatus(params.row._id)}
          >
            Change Status
          </Button>
        );
      }
    }
  ];

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Complaint-Management</Typography>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Complaints  ( {complaintData?.length} )
              </Typography>
              <DataGrid
                rows={complaintData}
                columns={columns}
                checkboxSelection
                getRowId={(row) => row?._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{ toolbar: { showQuickFilter: true } }}
              />
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default AdminComplaint;
